const VRI_CLASSIFIER = [
  {"name": "Иной вид", "desc": "", "code": "0.0"},
  {"name": "Сельскохозяйственное использование", "desc": "", "code": "1.0"},
  {"name": "Растениеводство", "desc": "", "code": "1.1"},
  {"name": "Выращивание зерновых и иных сельскохозяйственных культур", "desc": "", "code": "1.2"},
  {"name": "Овощеводство", "desc": "", "code": "1.3"},
  {"name": "Выращивание тонизирующих, лекарственных, цветочных культур", "desc": "", "code": "1.4"},
  {"name": "Садоводство", "desc": "", "code": "1.5"},
  {"name": "Виноградарство", "desc": "", "code": "1.5.1"},
  {"name": "Выращивание льна и конопли", "desc": "", "code": "1.6"},
  {"name": "Животноводство", "desc": "", "code": "1.7"},
  {"name": "Скотоводство", "desc": "", "code": "1.8"},
  {"name": "Звероводство", "desc": "", "code": "1.9"},
  {"name": "Птицеводство", "desc": "", "code": "1.10"},
  {"name": "Свиноводство", "desc": "", "code": "1.11"},
  {"name": "Пчеловодство", "desc": "", "code": "1.12"},
  {"name": "Рыбоводство", "desc": "", "code": "1.13"},
  {"name": "Научное обеспечение сельского хозяйства", "desc": "", "code": "1.14"},
  {"name": "Хранение и переработка сельскохозяйственной продукции", "desc": "", "code": "1.15"},
  {"name": "Ведение личного подсобного хозяйства на полевых участках", "desc": "", "code": "1.16"},
  {"name": "Питомники", "desc": "", "code": "1.17"},
  {"name": "Обеспечение сельскохозяйственного производства", "desc": "", "code": "1.18"},
  {"name": "Сенокошение", "desc": "", "code": "1.19"},
  {"name": "Выпас сельскохозяйственных животных", "desc": "", "code": "1.20"},
  {"name": "Жилая застройка", "desc": "", "code": "2.0"},
  {"name": "Для индивидуального жилищного строительства", "desc": "", "code": "2.1"},
  {"name": "Малоэтажная многоквартирная жилая застройка", "desc": "", "code": "2.1.1"},
  {"name": "Для ведения личного подсобного хозяйства (приусадебный земельный участок)", "desc": "", "code": "2.2"},
  {"name": "Блокированная жилая застройка", "desc": "", "code": "2.3"},
  {"name": "Передвижное жилье", "desc": "", "code": "2.4"},
  {"name": "Среднеэтажная жилая застройка", "desc": "", "code": "2.5"},
  {"name": "Многоэтажная жилая застройка (высотная застройка)", "desc": "", "code": "2.6"},
  {"name": "Обслуживание жилой застройки", "desc": "", "code": "2.7"},
  {"name": "Хранение автотранспорта", "desc": "", "code": "2.7.1"},
  {"name": "Размещение гаражей для собственных нужд", "desc": "", "code": "2.7.2"},
  {"name": "Общественное использование объектов капитального строительства", "desc": "", "code": "3.0"},
  {"name": "Коммунальное обслуживание", "desc": "", "code": "3.1"},
  {"name": "Предоставление коммунальных услуг", "desc": "", "code": "3.1.1"},
  {"name": "Административные здания организаций, обеспечивающих предоставление коммунальных услуг", "desc": "", "code": "3.1.2"},
  {"name": "Социальное обслуживание", "desc": "", "code": "3.2"},
  {"name": "Дома социального обслуживания", "desc": "", "code": "3.2.1"},
  {"name": "Оказание социальной помощи населению", "desc": "", "code": "3.2.2"},
  {"name": "Оказание услуг связи", "desc": "", "code": "3.2.3"},
  {"name": "Общежития", "desc": "", "code": "3.2.4"},
  {"name": "Бытовое обслуживание", "desc": "", "code": "3.3"},
  {"name": "Здравоохранение", "desc": "", "code": "3.4"},
  {"name": "Амбулаторно-поликлиническое обслуживание", "desc": "", "code": "3.4.1"},
  {"name": "Стационарное медицинское обслуживание", "desc": "", "code": "3.4.2"},
  {"name": "Медицинские организации особого назначения", "desc": "", "code": "3.4.3"},
  {"name": "Образование и просвещение", "desc": "", "code": "3.5"},
  {"name": "Дошкольное, начальное и среднее общее образование", "desc": "", "code": "3.5.1"},
  {"name": "Среднее и высшее профессиональное образование", "desc": "", "code": "3.5.2"},
  {"name": "Культурное развитие", "desc": "", "code": "3.6"},
  {"name": "Объекты культурно-досуговой деятельности", "desc": "", "code": "3.6.1"},
  {"name": "Парки культуры и отдыха", "desc": "", "code": "3.6.2"},
  {"name": "Цирки и зверинцы", "desc": "", "code": "3.6.3"},
  {"name": "Религиозное использование", "desc": "", "code": "3.7"},
  {"name": "Осуществление религиозных обрядов", "desc": "", "code": "3.7.1"},
  {"name": "Религиозное управление и образование", "desc": "", "code": "3.7.2"},
  {"name": "Общественное управление", "desc": "", "code": "3.8"},
  {"name": "Государственное управление", "desc": "", "code": "3.8.1"},
  {"name": "Представительская деятельность", "desc": "", "code": "3.8.2"},
  {"name": "Обеспечение научной деятельности", "desc": "", "code": "3.9"},
  {"name": "Обеспечение деятельности в области гидрометеорологии и смежных с ней областях", "desc": "", "code": "3.9.1"},
  {"name": "Проведение научных исследований", "desc": "", "code": "3.9.2"},
  {"name": "Проведение научных испытаний", "desc": "", "code": "3.9.3"},
  {"name": "Ветеринарное обслуживание", "desc": "", "code": "3.10"},
  {"name": "Амбулаторное ветеринарное обслуживание", "desc": "", "code": "3.10.1"},
  {"name": "Приюты для животных", "desc": "", "code": "3.10.2"},
  {"name": "Предпринимательство", "desc": "", "code": "4.0"},
  {"name": "Деловое управление", "desc": "", "code": "4.1"},
  {"name": "Объекты торговли (торговые центры, торгово-развлекательные центры (комплексы)", "desc": "", "code": "4.2"},
  {"name": "Рынки", "desc": "", "code": "4.3"},
  {"name": "Магазины", "desc": "", "code": "4.4"},
  {"name": "Банковская и страховая деятельность", "desc": "", "code": "4.5"},
  {"name": "Общественное питание", "desc": "", "code": "4.6"},
  {"name": "Гостиничное обслуживание", "desc": "", "code": "4.7"},
  {"name": "Развлечение", "desc": "", "code": "4.8"},
  {"name": "Развлекательные мероприятия", "desc": "", "code": "4.8.1"},
  {"name": "Проведение азартных игр", "desc": "", "code": "4.8.2"},
  {"name": "Проведение азартных игр в игорных зонах", "desc": "", "code": "4.8.3"},
  {"name": "Служебные гаражи", "desc": "", "code": "4.9"},
  {"name": "Объекты дорожного сервиса", "desc": "", "code": "4.9.1"},
  {"name": "Заправка транспортных средств", "desc": "", "code": "4.9.1.1"},
  {"name": "Обеспечение дорожного отдыха", "desc": "", "code": "4.9.1.2"},
  {"name": "Автомобильные мойки", "desc": "", "code": "4.9.1.3"},
  {"name": "Ремонт автомобилей", "desc": "", "code": "4.9.1.4"},
  {"name": "Стоянка транспортных средств", "desc": "", "code": "4.9.2"},
  {"name": "Выставочно-ярмарочная деятельность", "desc": "", "code": "4.10"},
  {"name": "Отдых (рекреация)", "desc": "", "code": "5.0"},
  {"name": "Спорт", "desc": "", "code": "5.1"},
  {"name": "Обеспечение спортивно-зрелищных мероприятий", "desc": "", "code": "5.1.1"},
  {"name": "Обеспечение занятий спортом в помещениях", "desc": "", "code": "5.1.2"},
  {"name": "Площадки для занятий спортом", "desc": "", "code": "5.1.3"},
  {"name": "Оборудованные площадки для занятий спортом", "desc": "", "code": "5.1.4"},
  {"name": "Водный спорт", "desc": "", "code": "5.1.5"},
  {"name": "Авиационный спорт", "desc": "", "code": "5.1.6"},
  {"name": "Спортивные базы", "desc": "", "code": "5.1.7"},
  {"name": "Природно-познавательный туризм", "desc": "", "code": "5.2"},
  {"name": "Туристическое обслуживание", "desc": "", "code": "5.2.1"},
  {"name": "Деятельность в сфере охотничьего хозяйства", "desc": "", "code": "5.3"},
  {"name": "Рыболовство", "desc": "", "code": "5.3.1"},
  {"name": "Причалы для маломерных судов", "desc": "", "code": "5.4"},
  {"name": "Поля для гольфа или конных прогулок", "desc": "", "code": "5.5"},
  {"name": "Производственная деятельность", "desc": "", "code": "6.0"},
  {"name": "Разведка и добыча полезных ископаемых", "desc": "", "code": "6.1"},
  {"name": "Осуществление геологического изучения недр", "desc": "", "code": "6.1.1"},
  {"name": "Тяжелая промышленность", "desc": "", "code": "6.2"},
  {"name": "Автомобилестроительная промышленность", "desc": "", "code": "6.2.1"},
  {"name": "Легкая промышленность", "desc": "", "code": "6.3"},
  {"name": "Фармацевтическая промышленность", "desc": "", "code": "6.3.1"},
  {"name": "Фарфоро-фаянсовая промышленность", "desc": "", "code": "6.3.2"},
  {"name": "Электронная промышленность", "desc": "", "code": "6.3.3"},
  {"name": "Ювелирная промышленность", "desc": "", "code": "6.3.4"},
  {"name": "Пищевая промышленность", "desc": "", "code": "6.4"},
  {"name": "Нефтехимическая промышленность", "desc": "", "code": "6.5"},
  {"name": "Строительная промышленность", "desc": "", "code": "6.6"},
  {"name": "Энергетика", "desc": "", "code": "6.7"},
  {"name": "Атомная энергетика", "desc": "", "code": "6.7.1"},
  {"name": "Связь", "desc": "", "code": "6.8"},
  {"name": "Склад", "desc": "", "code": "6.9"},
  {"name": "Складские площадки", "desc": "", "code": "6.9.1"},
  {"name": "Обеспечение космической деятельности", "desc": "", "code": "6.10"},
  {"name": "Целлюлозно-бумажная промышленность", "desc": "", "code": "6.11"},
  {"name": "Научно-производственная деятельность", "desc": "", "code": "6.12"},
  {"name": "Транспорт", "desc": "", "code": "7.0"},
  {"name": "Железнодорожный транспорт", "desc": "", "code": "7.1"},
  {"name": "Железнодорожные пути", "desc": "", "code": "7.1.1"},
  {"name": "Обслуживание железнодорожных перевозок", "desc": "", "code": "7.1.2"},
  {"name": "Автомобильный транспорт", "desc": "", "code": "7.2"},
  {"name": "Размещение автомобильных дорог", "desc": "", "code": "7.2.1"},
  {"name": "Обслуживание перевозок пассажиров", "desc": "", "code": "7.2.2"},
  {"name": "Стоянки транспорта общего пользования", "desc": "", "code": "7.2.3"},
  {"name": "Водный транспорт", "desc": "", "code": "7.3"},
  {"name": "Воздушный транспорт", "desc": "", "code": "7.4"},
  {"name": "Трубопроводный транспорт", "desc": "", "code": "7.5"},
  {"name": "Внеуличный транспорт", "desc": "", "code": "7.6"},
  {"name": "Обеспечение обороны и безопасности", "desc": "", "code": "8.0"},
  {"name": "Обеспечение вооруженных сил", "desc": "", "code": "8.1"},
  {"name": "Охрана Государственной границы Российской Федерации", "desc": "", "code": "8.2"},
  {"name": "Обеспечение внутреннего правопорядка", "desc": "", "code": "8.3"},
  {"name": "Обеспечение деятельности по исполнению наказаний", "desc": "", "code": "8.4"},
  {"name": "Деятельность по особой охране и изучению природы", "desc": "", "code": "9.0"},
  {"name": "Охрана природных территорий", "desc": "", "code": "9.1"},
  {"name": "Сохранение и репродукция редких и (или) находящихся под угрозой исчезновения видов животных", "desc": "", "code": "9.1.1"},
  {"name": "Курортная деятельность", "desc": "", "code": "9.2"},
  {"name": "Санаторная деятельность", "desc": "", "code": "9.2.1"},
  {"name": "Историко-культурная деятельность", "desc": "", "code": "9.3"},
  {"name": "Использование лесов", "desc": "", "code": "10.0"},
  {"name": "Заготовка древесины", "desc": "", "code": "10.1"},
  {"name": "Заготовка живицы", "desc": "", "code": "10.2"},
  {"name": "Заготовка и сбор недревесных лесных ресурсов", "desc": "", "code": "10.3"},
  {"name": "Заготовка пищевых лесных ресурсов и сбор лекарственных растений", "desc": "", "code": "10.4"},
  {"name": "Выращивание лесных плодовых, ягодных, декоративных растений, лекарственных растений", "desc": "", "code": "10.5"},
  {"name": "Создание лесных плантаций и их эксплуатация", "desc": "", "code": "10.6"},
  {"name": "Создание лесных питомников и их эксплуатация", "desc": "", "code": "10.7"},
  {"name": "Создание и эксплуатация объектов лесоперерабатывающей инфраструктуры", "desc": "", "code": "10.8"},
  {"name": "Осуществление научно-исследовательской деятельности, образовательной деятельности в лесах", "desc": "", "code": "10.9"},
  {"name": "Осуществление рекреационной деятельности в лесах", "desc": "", "code": "10.10"},
  {"name": "Водные объекты", "desc": "", "code": "11.0"},
  {"name": "Общее пользование водными объектами", "desc": "", "code": "11.1"},
  {"name": "Специальное пользование водными объектами", "desc": "", "code": "11.2"},
  {"name": "Гидротехнические сооружения", "desc": "", "code": "11.3"},
  {"name": "Земельные участки (территории) общего пользования", "desc": "", "code": "12.0"},
  {"name": "Улично-дорожная сеть", "desc": "", "code": "12.0.1"},
  {"name": "Благоустройство территории", "desc": "", "code": "12.0.2"},
  {"name": "Ритуальная деятельность", "desc": "", "code": "12.1"},
  {"name": "Специальная деятельность", "desc": "", "code": "12.2"},
  {"name": "Запас", "desc": "", "code": "12.3"},
  {"name": "Земельные участки общего назначения", "desc": "", "code": "13.0"},
  {"name": "Ведение огородничества", "desc": "", "code": "13.1"},
  {"name": "Ведение садоводства", "desc": "", "code": "13.2"},
  {"name": "Земельные участки, входящие в состав общего имущества собственников индивидуальных жилых домов в малоэтажном жилом комплексе", "desc": "", "code": "14.0"}
];

// Helper: get VRI name by code
function getVriName(code) {
  if (!code) return '';
  const item = VRI_CLASSIFIER.find(function(v) { return v.code === String(code); });
  return item ? item.name : '';
}

function findVriByName(name) {
  if (!name) return null;
  const trimmed = String(name).trim();
  return VRI_CLASSIFIER.find(function(v) { return v.name === trimmed; }) || null;
}

function getVriDisplayName(name) {
  const item = findVriByName(name);
  return item ? (item.code ? item.name + ' (' + item.code + ')' : item.name) : name;
}

function getVriDescription(name) {
  const item = findVriByName(name);
  return item ? item.desc : '';
}

function getVriCode(name) {
  const item = findVriByName(name);
  return item ? item.code : '';
}

if (typeof window !== 'undefined') {
  window.VRI_CLASSIFIER = VRI_CLASSIFIER;
  window.getVriName = getVriName;
  window.findVriByName = findVriByName;
  window.getVriDisplayName = getVriDisplayName;
  window.getVriDescription = getVriDescription;
  window.getVriCode = getVriCode;
}
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { VRI_CLASSIFIER, getVriName, findVriByName, getVriDisplayName, getVriDescription, getVriCode };
}
